const DetailsCard = ({onEnquire}) => {
  return (
    <div className="bg-white w-[340px] rounded-2xl shadow-2xl overflow-hidden">
      <div className="bg-lime-700 text-white text-center py-2 text-sm">
        Booking Open
      </div>

      <div className="p-5 text-center">
        <h2 className="text-xl font-bold">GODREJ VARANYA</h2>
        <p className="text-sm text-gray-600">By Godrej Properties</p>
        <p className="text-xs text-gray-500 mt-1">
          Sector 5A, Kharghar-Belapada, Navi Mumbai
        </p>

        <div className="mt-4 space-y-2 text-sm text-white">
          <div className="bg-lime-600 py-1 rounded">
            ◆ EOI Benefits Upto ₹40 Lacs*
          </div>
          <div className="bg-lime-600 py-1 rounded">
            ◆ EOI Starts ₹2 Lacs*
          </div>
          <div className="bg-lime-600 py-1 rounded">
            ◆ 20 Mins Airport
          </div>
          <div className="bg-lime-600 py-1 rounded">
            ◆ 2 Mins Metro & Rly Stn.
          </div>
        </div>

        <div className="mt-4">
          <p className="text-sm">Luxury 2 & 3 BHK Starts</p>
          <p className="text-2xl font-bold text-lime-700">
            ₹ 2.25 Cr* Onwards
          </p>
        </div>

        <button className="mt-4 w-full bg-[#7c9a1f] hover:bg-[#6b8518] text-white py-2 rounded-lg font-medium" onClick={onEnquire}>
          Enquire Now
        </button>
      </div>
    </div>
  );
};

export default DetailsCard;